import React from 'react';

import { Switch, Route } from 'react-router-dom';

import TicketTable from './table.js'
import TicketForm from './form.js'
import Term from './term.js'

export default (props) => {
    return(
        <Switch>
            <Route exact path='/tickets' component={TicketTable} />
            <Route exact path='/tickets/ver/:id' component={TicketForm} />
            <Route exact path='/tickets/term/:id' component={Term} />
            <Route exact path='/tickets/agregar' component={TicketForm} />
        </Switch>
    )
}





// WEBPACK FOOTER //
// ./src/views/ticket/index.js